module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


// WEBPACK FOOTER //
// webpack:///node_modules/babel-runtime/core-js/array/from.js